import { render, staticRenderFns } from "./HolidayEdit.vue?vue&type=template&id=6dfeef7a&"
import script from "./HolidayEdit.vue?vue&type=script&lang=js&"
export * from "./HolidayEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports